import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages are pre-rendered to static HTML at build time; hydrate when present
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, { onRecoverableError: () => {} });
} else {
  ReactDOM.createRoot(container).render(app);
}
